/* eslint-disable no-unused-expressions */

import {
  dangerMessage,
  successMessage,
  warningMessage,
} from "../components/Toast/Toast";

async function Post(
  endPoint,
  bodyContent,
  Method,
  displayMessage,
  token,
  isJSON
) {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  isJSON ? null : myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: Method,
    headers: myHeaders,
    body: bodyContent,
    redirect: "follow",
  };

  const result = await fetch(
    `${process.env.REACT_APP_API}${endPoint}`,
    requestOptions
  )
    .then((response) => response.json())
    .then((res) => {
      if (res?.status === "success") {
        displayMessage === null ? null : successMessage(`${displayMessage}`);
        return res;
      }
      if (res?.status === "fail") {
        const error = res?.message ? res?.message : res?.data;
        warningMessage(`${error} `);
        return Promise.reject(new Error(error));
      }
      if (res?.status === "error") {
        const error = res?.message ? res?.message : res?.data;
        dangerMessage(`${error}`);
        if (res?.message === "jwt malformed") {
          dangerMessage("You need to login");
        }
        return Promise.reject(new Error(error));
      }
      return Promise.reject(new Error("Unexpected response from server"));
    })
    .catch((error) => {
      if (!error?.message || error.message === "Failed to fetch") {
        dangerMessage("Network issue please try again");
      }
      return Promise.reject(error);
    });
  return result;
}

export default Post;
